// Hooks
export {
  useModuleAccess,
  default as useModuleAccessDefault,
} from './hooks/useModuleAccess';

// Components
export { ModuleActionButtons } from './components/ModuleActionButtons';

// Definitions
export {
  quickLinkModuleDefinitions,
  quickLinkModuleKeys,
  type QuickLinkModuleKey,
} from './definitions/quickLinkModules';

// Types
export type {
  ModuleDefinition,
  ModuleActionType,
  ModuleModalProps,
  ModuleAccessResult,
  UserRestriction,
} from './types';
